<template>
  <div>
    <div v-if="show_cv">
      <a @click="openCV()" class="button is-info is-outlined">Download CV</a>
    </div>
    <div v-for="attribute in extra_attributes" :key="attribute.name">
      <img
        v-if="attribute.name != 'cv'"
        @mouseover="onMouseOver(attribute)"
        @mouseleave="onMouseLeave"
        class="operation_icon"
        :src="attribute.icon"
      />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
export default {
  name: 'extra-attributes',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      extra_attributes: [],
      show_cv: false
    }
  },
  created: function () {
    let extra_attributes = this.payload.extra_attributes
    if (extra_attributes == 'null') {
      return
    }
    extra_attributes = JSON.parse(extra_attributes)
    for (let attribute in extra_attributes) {
      let attribute_data = extra_attributes[attribute]
      if (attribute_data == undefined) {
        continue
      }
      if (attribute == 'Cv' && attribute_data.cv == true) {
        this.show_cv = true
        continue
      }
      this.extra_attributes.push({
        name: attribute,
        icon: '/extra_attribute_' + attribute.toLowerCase() + '.png',
        data: attribute_data
      })
    }
  },
  computed: {
    ...mapGetters('modals', ['findModal'])
  },
  methods: {
    openCV () {
      this.$network_utils.downloadCv({ current_resource_id: this.payload.resource_id, current_type: this.payload.resource_type })
    },
    onMouseLeave () {
      this.remove(this.findModal({ type: 'designator', value: 'extra-attributes-modal' }))
    },
    onMouseOver (attribute) {
      this.create({ designator: 'extra-attributes-modal', component_name: 'ExtraAttributesForm', attribute, modal_title: attribute.name })
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
